module.exports = __webpack_public_path__ + "assets/img/KS8223-M.f209222c.png";